export const roles = [
    {
        id: 'none',
        label: 'Select role'
    },
    {
        id: 'csuiteVP',
        label: 'C-Suite Executive / VP'
    },
    {
        id: 'directorGM',
        label: 'Director / General Manager'
    },
    {
        id: 'managerAdministratorSupervisor',
        label: 'Manager / Administrator / Supervisor'
    },
    {
        id: 'nonManagement',
        label: 'Non-management position'
    }
];


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/component/main/content/profile/formData/roles.ts